import {memo} from 'react'
import {Tooltip, Drawer,Typography,Stack, Button} from '@mui/material';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageComponent from './imageComponent.jsx'
import EditLocationIcon from '@mui/icons-material/EditLocation';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { accentSurface } from '../utils/colorDict';

const LocationEditWidget = memo(({mapRef,
                        itemsToEdit,
                        itemToDelete,
                        handleItemToDelete,
                        itemToPosition,
                        handleItemToPosition,
                        handleDeletionPromptOpen,                       
                        rightPanel,
                        handleRightPanel,
                        cancelBeam,
                        handleItemsToMark,
                        handleModalData
                        })=>{

return <Drawer
PaperProps={{ style: {height: 'calc(100% - 80px)',top:'80px',zIndex:2,minWidth:'400px',overflowX:'hidden',background:'whitesmoke' }}}
variant="persistent"
anchor={'left'}
onClose={()=>{handleRightPanel(0)}}
open={rightPanel===2}
>

<ImageList sx={{backgroundColor:accentSurface,
                padding:'10px 10px 0',
                margin:0,
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px', 
                display:'flex',
                flexDirection:'column',
                alignItems:'center'}} 
          cols={1}>
<Typography variant='h6'>Photograph Location Edit</Typography>

{itemsToEdit.map((item,i) => (
  <ImageListItem key={i} style={{direction:'rtl',height:'260px',margin:'4vh 0',boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'}}
  >

  <ImageComponent 
    imageUrl={item.properties.right_panel_url}
    h='200px'
    w='400px'
    cu='pointer'
    objectF='contain'
    handleClick={()=>{handleModalData(item, item.properties.mediatype)}}
  />

  <Stack direction="row" spacing={2} sx={{justifyContent:'space-between',padding:'12px 10px 0',direction:'ltr'}}>

  <Button variant={item===itemToPosition ? "outlined" : 'contained'} sx={{direction:'ltr'}} endIcon={<EditLocationIcon />} 
  onClick={()=>{ 
    cancelBeam()
    if (item===itemToPosition){
      handleItemToPosition(null)
      handleItemsToMark([])
    } else {
      handleItemToPosition(item)
    }
  }}
  >
    <Typography>{item===itemToPosition ? "cancel" : "Edit location"}</Typography>
  </Button>

  <Button  variant={item===itemToDelete ? "outlined" : 'contained'} sx={{direction:'ltr'}} endIcon={<DeleteForeverIcon />}
    onClick={()=>{ 
      if (item===itemToDelete){
        console.log('same item')
      }else{
        handleItemToDelete(item)
        handleDeletionPromptOpen()
        }
      }
    }
  >
  <Typography > Delete </Typography>
  </Button>  
</Stack>

</ImageListItem>
))}
</ImageList>
</Drawer>  
  
 });
   
export default LocationEditWidget